export const UserRole = {
    ADMIN: "ADMIN",
    APPLICANT: "APPLICANT",
    COMPANY: "COMPANY",
};
